exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#the-canvas[data-v-0d78c4ca]{border:1px solid #000;direction:ltr}.iframe-pdf[data-v-0d78c4ca]{height:700px;width:100%;border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d78c4ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pdf-preview.vue
// module id = 5
// module chunks = 0